export function ageFromDob(dob: string, now: Date = new Date()): number | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dob);
  if (!m) return null;
  const [, yStr, mStr, dStr] = m;
  if (!yStr || !mStr || !dStr) return null;
  const y = Number(yStr), mo = Number(mStr), d = Number(dStr);
  if (!Number.isFinite(y) || !Number.isFinite(mo) || !Number.isFinite(d)) return null;
  let age = now.getFullYear() - y;
  const before = now.getMonth() + 1 < mo || (now.getMonth() + 1 === mo && now.getDate() < d);
  if (before) age -= 1;
  return age >= 0 && age < 120 ? age : null;
}

export function isValidPastDob(dob: string, maxYearsBack = 25): boolean {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dob);
  if (!m) return false;
  const ts = Date.parse(`${dob}T00:00:00Z`);
  if (!Number.isFinite(ts)) return false;
  const now = Date.now();
  const minTs = now - maxYearsBack * 365.25 * 24 * 60 * 60 * 1000;
  return ts < now && ts > minTs;
}
